<template>
  <!--    :disabled="selectFieldConfig.disabled"-->
  <a-select
    v-model="changeValue"
    showSearch
    optionFilterProp="label"
    :ref="`select_${field.fieldCode}`"
    :allowClear="parameters.clearable"
    :defaultValue="parameters.defaultValue"
    :class="{ 'show-placeholder': changeValue === '' }"
    :placeholder="selectFieldConfig.placeholder || parameters.placeholder"
    :open.sync="openOption"
    @dropdownVisibleChange="onDropdownVisibleChange"
  >
    <template v-for="(item, index) in options">
      <a-select-option
        :key="`select_${index}`"
        :value="item.value"
        :label="item.label"
      >
        <span v-if="parameters.isSelectShowColor" :class="item.color"></span>
        {{ item.label }}
      </a-select-option>
    </template>
  </a-select>
</template>

<script>
import { DataEntryMixin } from "./mixins";

export default {
  name: "SdSelect",
  mixins: [DataEntryMixin],
  props: {
    // 下拉字段规则字段配置
    selectFieldConfig: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    options() {
      const sourceData = this.parameters.options || [];
      const options = [];
      if (this.selectFieldConfig.optionalValues.length) {
        sourceData.forEach((item) => {
          if (
            this.selectFieldConfig.optionalValues.includes(item.value) &&
            item.isEnable
          ) {
            options.push(item);
          }
        });
        // 非可选值，置空
        // if (this.value && !this.selectFieldConfig.optionalValues.includes(this.value)) {
        //     this.$emit('update:value', '')
        // }
      } else {
        sourceData.forEach((item) => {
          if (item.isEnable) {
            options.push(item);
          }
        });
      }
      return options;
    },
  },
  data() {
    return {
      openOption: false,
    };
  },

  methods: {
    onDropdownVisibleChange(open) {
      if (open && this.selectFieldConfig.disabled) {
        this.$message.warning(this.selectFieldConfig.placeholder);
        this.$refs[`select_${this.field.fieldCode}`].blur();
        this.openOption = false;
      } else {
        this.openOption = open;
      }
    },
  },
};
</script>

<style lang="less">
.show-placeholder {
  .ant-select-selection__placeholder {
    display: inline-block !important;
  }
}
</style>
